import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { Region } from "../core/components/region.js";
import { Grid } from "../../app/core/components/grid.js";
import { MonacoEditor } from "../core/components/monacoEditor.js"
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { Helper } from "../core/util/helper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { FAIcon } from "../core/components/faIcon.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import React from "react";
import ReactDOM from "react-dom";

export class InfoToolJob extends React.Component<InfoToolJobProps, any> {
    private factory = ComponentHelper.createFactory();
    common = new AppHelper();
    showEmailTemplates: boolean;
    private fields: { id: number, fields: any }[];
    constructor(props: InfoToolJobProps) {
        super(props);
        this.common.init(this);
        this.setShowEmailTemplates();


        this.fields = props.metadata.additional.objects.find(f => f.name == "fields").data;
    }

    private setShowEmailTemplates = () => {
        this.showEmailTemplates = this.props.entity.Reaction == ReactionType.MailTemplate;
        this.setState({})
        
    }

    private validate = async () => {
        if (!this.common.validate()) {
            return false;
        }
        if (Helper.isNullOrEmpty(this.props.entity.Sql)) {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("InfoTool.NoSqL"));
            if (!isOk)
                return false;
        }

        return true;
    }

    save = async () => {
        const isOk = await this.validate();
        if (isOk) {
            const result = await HTTPService.post<JsonResultClass>("InfotoolJob/Save", {
                model: this.props.entity
            })
            if (result.Code == 0) {
                if (this.props.entity.IsNew) {
                    General.Functions.HistoryState.replaceState("InfotoolJob/Edit?id=" + this.props.entity.Id);
                }
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, false);
            this.setState({}, this.setTitle);
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, this.setShowEmailTemplates);
    }

    componentDidMount() {
        this.setTitle();
        this.setStyles();
    }



    private setTitle = () => {
        this.common.updateSheetTitle(this.props.entity.Name || Helper.getTranslation("InfoTool.NewJob"));
    }

    private setStyles = () => {
        const el = document.querySelector('.grid-layout-container__item:nth-child(2) .field-instance') as any;
        el.style.padding = 0;
    }

    private renderSQLGrid = () => {
        const gridOptions: kendo.ui.GridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "sql",
                    title: Helper.getTranslation("InfoTool.SQL"),
                    template: () => {
                        const maxlenght = 450;
                        let sql = this.props.entity.Sql;
                        sql = Helper.isNullOrEmpty(sql) ? Helper.getTranslation("InfoTool.NoSqlDefined") : sql;
                        const arr = sql.split(/\r\n/g);
                        sql = arr.length >= 1 ? arr[0] : sql;

                        if (sql.length >= maxlenght)
                            sql = sql.substring(0, maxlenght) + "..."

                        return sql
                    }
                }
            ]
        };

        const buttons: Array<GridCustomToolBarButton> = [
            {
                caption: Helper.isNullOrEmpty(this.props.entity.Sql) ? Helper.getTranslation("InfoTool.NewSql") : Helper.getTranslation("InfoTool.EditSQL"),
                enabled: true,
                iconClass: Helper.isNullOrEmpty(this.props.entity.Sql) ? "fa-light fa-plus" : "fa-light fa-pen",
                id: Helper.isNullOrEmpty(this.props.entity.Sql) ? "new" : "edit",
                autoEnabledOnRecordSelected: false
            }
        ];

        const onClick = async () => {
            const entity = await openSQLEditor({ Id: -1, LetzteAusfuehrung: null, SQL: this.props.entity.Sql, Success: 0 }, false);
            this.handleFieldChange({ model: "entity.Sql" }, entity.SQL);
        }

        const data = [];
        data.push({ sql: Helper.isNullOrEmpty(this.props.entity.Sql) ? "" : this.props.entity.Sql })


        return (
                <div className="flex-container">
                    <Grid
                    data={data}
                    options={gridOptions}
                    id="sql"
                    customButtons={buttons}
                    onClickCustomButton={onClick}
                    />
                </div>
        );
    }

    renderSqls = () => {

        return (
            <>
                <div style={{ display: "grid", gridTemplateColumns: "auto", gridTemplateRows: "repeat(2, auto)" }} >
                    <Region key={"2"} title={Helper.getTranslation("InfoTool.SQL")}>
                        {this.renderSQLGrid()}
                    </Region>
                    <Region key={"1"} title={Helper.getTranslation("InfoTool.FolgeSQL")}>
                        <FolgeSqls data={this.props.entity.FolgeSqls} onChange={(items) => { this.handleFieldChange({ model: "entity.FolgeSqls" }, items) }} />
                    </Region>

                </div>
            </>
        );
    }

    renderEmailTemplates = () => {
        return (
            <>
                <EmailTemplateGrid ids={this.props.entity.EmailTemplates} onChange={(items) => { this.handleFieldChange({ model: "entity.EmailTemplates" }, items) }} />
            </>
        );
    }

    renderFieldsInfo = () => {
        const gridOptions: kendo.ui.GridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "mandatory",
                    title: Helper.getTranslation("WebCRM.EditIndividualFields.Mandatory"),
                    width: 130,
                    template: (dataItem: any) => {
                        let icon = ""
                        if (dataItem.mandatory) {
                            icon = '<i class="fa-light fa-check"></i>'
                        } else {
                            icon = '<i class="fa-light fa-xmark"></i>'
                        }
                        return `<div style="display: flex; justify-content: center; align-items: center">${icon}</div>`
                    }
                },
                {
                    field: "name",
                    title: Helper.getTranslation("BrowserTitle.Resource.Available"),
                    width: 140,
                },
                {
                    field: "dataType",
                    title: Helper.getTranslation("WebSMS.Report.Question.Search.Datentyp"),
                    width: 120,
                },
                {
                    field: "size",
                    title: Helper.getTranslation("WebSMS.GeneralSettings.Style.Type.Size"),
                    width: 120,
                },
                {
                    field: "description",
                    title: Helper.getTranslation("Field.fstasks.Workpackage.Description")
                }

            ]
        }

        return (
            <div className="flex-container" style={{ maxHeight: "500px" }} >
                <Grid
                    data={this.fields.find(f => f.id == this.props.entity.Reaction).fields}
                    options={gridOptions}
                    id="jhgjhgf"
                />
            </div>
        );


    }

    renderDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = this.props.entity.Reaction;
        props.dataSource = this.props.dataSources.reactionTypes;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.optionLabel = "";
        props.onChange = (_, value) => {
            this.handleFieldChange({ model: "entity.Reaction"}, value);
        }

        let info: string | JSX.Element;
        switch (this.props.entity.Reaction) {
            case ReactionType.BackupFiles:
                break;
            case ReactionType.EMail:
                info = Helper.getTranslation("InfoTool.Reaction.Info.EMail");
                break;
            case ReactionType.Empty:
                info = Helper.getTranslation("InfoTool.Reaction.Info.Empty")
                break;
            case ReactionType.FileSendMail:
                info = Helper.getTranslation("InfoTool.Reaction.Info.FileSendMail");
                break;
            case ReactionType.FileSendMailRecipients:
                info = Helper.getTranslation("InfoTool.Reaction.Info.FileSendMailRecipients");
                break;
            case ReactionType.GenerateDocumentFromQRA:
                info = Helper.getTranslation("InfoTool.Reaction.Info.GenerateDocumentFromQRA");
                break;
            case ReactionType.GenerateReportPDF:
                info = Helper.getTranslation("InfoTool.Reaction.Info.GenerateReportPDF");
                break;
            case ReactionType.MailTemplate:
                info = Helper.getTranslation("InfoTool.Reaction.Info.MailTemplate");
                break;
            case ReactionType.SMS:
                info = Helper.getTranslation("InfoTool.Reaction.Info.SMS");
                break;
            case ReactionType.Ticket:
                info = Helper.getTranslation("InfoTool.Reaction.Info.Ticket");
                break;
            case ReactionType.Todo:
                break;
        }

        if (Helper.hasValue(info)) {
            info = (
                <div style={{ padding: "3px", lineHeight: "1.2em", fontSize: "12px", display: "flex", flexDirection: "row-reverse" }} >
                    {info}
                </div>
            );
        }

        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ flex: 1 }}><DropDownList {...props} /></div>
                {info}
            </div>
        );
    }

    renderInfo = () => {
        const isActive = this.props.entity.Aktiv;
        const color = isActive ? "#2e7d32" : "#d50000";
        const messageKey = isActive ? "InfoTool.JobIsActive" : "InfoTool.JobIsNotActive";
        const iconName = isActive ? "check" : "xmark";

        return (
            <div style={{ border: `4.5px solid`, borderLeftWidth: "9px", padding: "8px", borderRadius: "4px", color: color, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }} >
                <FAIcon name={iconName} attributes={["2xl"]} />
                <div>{Helper.getTranslation(messageKey)}</div>
            </div>
        );
    }

    remove = async () => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOk)
            return;

        const result = await HTTPService.get<JsonResultClass>(`InfotoolJob/Delete?id=${this.props.entity.Id}`);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
            const isWindow = General.Sheet.Manager.getSheetsCount() > 1;
            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
            if (isWindow) {
                this.common.sheetWrapper.hide();
            } else {
                setTimeout(() => {
                    window.location.href = Config.baseUrl + "DynamicSearch/infotool";
                }, 500);
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    enable = async () => {
        let isOk = true;
        const messages: string[] = [];
        if (!Helper.hasValue(this.props.entity.FrequenzWert) || this.props.entity.FrequenzWert < 1) {
            isOk = false;
            messages.push(Helper.getTranslation("InfoTool.NotZero"));
        }

        if (Helper.isNullOrEmpty(this.props.entity.Sql)) {
            isOk = false;
            messages.push(Helper.getTranslation("InfoTool.NoSqlDefined"));
        }

        if (isOk) {
            this.handleFieldChange({ model: "entity.Aktiv" }, true)
        } else {
            messages.unshift(Helper.getTranslation("InfoTool.CanNotActivated"));
            await DialogHelper.ask({ header: Helper.getTranslation("InfoTool.CanNotActivated"), text: messages.join(". ") + "." });
        }
    }

    exportJSON = () => {
        Helper.openInNewBrowserTab(Config.baseUrl + "InfotoolJob/Export?id=" + this.props.entity.Id);
    }

    importJSON = async () => {
        try {
            const vm = await importJSON();
            if (vm) {
                Helper.updateEntity(this.props.entity, vm)
                this.setState({})
            }
        } catch (msg) {
            NotificationHelper.showErrorMessage(msg)
        }
    }

    disable = () => {
        this.handleFieldChange({ model: "entity.Aktiv"}, false)
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} title={this.props.title} />;
    }
};

export interface InfoToolJobProps extends AppBaseProps {
    entity: JobEntity//|any;
}

interface JobEntity extends Entity {
    Reaction: ReactionType;
    Sql: string;
    FolgeSqls: FolgeSQL[];
    EmailTemplates: number[];
    Id: any;
    Name: string;
    FrequenzWert: number;
    Aktiv: boolean;
}

enum ReactionType {
    SMS = 0,
    EMail = 1,
    Todo = 2,
    Ticket = 3,
    FileSendMail = 4,
    GenerateReportPDF = 5,
    Empty = 6,
    GenerateDocumentFromQRA = 7,
    FileSendMailRecipients = 8,
    BackupFiles = 9,
    MailTemplate = 10,
    HTTPRequest = 11
}

class FolgeSqls extends React.Component<FolgeSqlsProps, any>{
    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "SQLPreview",
                title: Helper.getTranslation("InfoTool.SQL"),
                template: (dataItem: FolgeSQL) => {
                    const maxlenght = 30;
                    if (!Helper.isNullOrEmpty(dataItem.SQL) && dataItem.SQL.length >= maxlenght)
                        return dataItem.SQL.substring(0, maxlenght) + "..."
                    return dataItem.SQL;
                }
            },
            {
                field: "LetzteAusfuehrung",
                title: Helper.getTranslation("WebCRM.Tasks.RecurringTask.LastExecution"),
                template: (dataItem: FolgeSQL) => {
                    if (Helper.hasValue(dataItem.LetzteAusfuehrung))
                        return kendo.toString(kendo.parseDate(dataItem.LetzteAusfuehrung.toString()), 'g')

                    return Helper.getTranslation("InfoTool.SQLDidntExec")
                }
            },
            {
                field: "Info",
                title: Helper.getTranslation("WebCRM.Email.Status.Success"),
                template: (dataItem: FolgeSQL) => {

                    switch (dataItem.Success) {
                        case 0:
                            return Helper.getTranslation("InfoTool.Success.NeverExecuted");
                        case 1:
                            return Helper.getTranslation("InfoTool.Success.Succes");
                        case 2:
                            return Helper.getTranslation("InfoTool.Success.NoSuccess");
                    }
                }
            }

        ]
    }

    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Helper.getTranslation("Standard.Neu"),
            enabled: true,
            type: ToolBarStandardButtonType.NEW
        },
        {
            caption: Helper.getTranslation("CustomerPortal.Approval.Actions.Edit"),
            enabled: true,
            type: ToolBarStandardButtonType.EDIT
        },
        {
            caption: Helper.getTranslation("Standard.Loeschen"),
            enabled: true,
            type: ToolBarStandardButtonType.DELETE
        },

    ];

    private onClick = async (type: ToolBarStandardButtonType, dataItem: FolgeSQL) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const ids = this.props.data.map(item => item.Id);
                ids.push(0); //js ist gruselig
                this.editSQL({
                    Id: Math.max(...ids) + 1,
                    LetzteAusfuehrung: null,
                    SQL: "",
                    Success: 0
                }, true);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.editSQL(dataItem, false);
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
                if (isOk) {
                    let items = this.props.data;
                    items = items.filter(item => item.Id != dataItem.Id)
                    this.props.onChange(items);
                }
                break;
        }
    }

    private editSQL = async (dataItem: FolgeSQL, isNew: boolean) => {
        const entity = await openSQLEditor(dataItem, isNew);


        const items = this.props.data;
        if (entity.IsNew) {
            items.push(entity);
        } else {
            const index = items.findIndex(item => item.Id == entity.Id)
            items[index].SQL = entity.SQL;
        }
        this.props.onChange(items)


    }

    render() {
        return (
            <div className="flex-container" style={{ maxHeight: "500px" }} >
                <Grid
                    data={this.props.data}
                    options={this.gridOptions}
                    id="folgeSqls"
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onClick}
                />
            </div>
        );
    }
}

interface FolgeSqlsProps {
    onChange: (data: FolgeSQL[]) => void;
    data: FolgeSQL[];
}

interface FolgeSQL {
    Id: number;
    LetzteAusfuehrung: Date|string;
    SQL: string;
    Success: number;
}


const openSQLEditor = (dataItem: FolgeSQL, isNew: boolean) => {
    return new Promise<FolgeSQLEntity>((resolve) => {

        const entity = dataItem as FolgeSQLEntity;
        entity.IsNew = isNew;
        entity.RecordRight = {
            CanRead: true,
            CanWrite: true
        }

        const sheet = General.Sheet.Manager.createSheet();
        const props: EditFolgeSQLProps = {
            context: {

            },
            dataSources: {},
            entity: entity,
            isWindow: false,
            metadata: {
                tabs: [
                    {
                        title: "",
                        component: "renderEditor()"
                    }
                ],
                menuDataSource: [
                    {
                        type: "save"
                    },
                ],
                additional: {
                    objects: []
                }
            },
            title: Helper.getTranslation("InfoTool.EditSQL")
        }
        sheet.show(() => {
            sheet.mountContent(EditSQL, props as any);
        });
        sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: FolgeSQLEntity }) => {
            resolve(data.entity)
        })
    })
}

class EditSQL extends React.Component<EditFolgeSQLProps, any> {
    common = new AppHelper();
    constructor(props: InfoToolJobProps) {
        super(props as any);
        this.common.init(this);
    }

    private onKeyPress = (value) => {
        this.handleFieldChange({model: "entity.SQL"}, value);
    }

    renderEditor = () => {
        return <div style={{ height: "100%" }}><MonacoEditor language="sql" code={this.props.entity.SQL} onKeyPress={this.onKeyPress} /></div>
    }

    handleFieldChange = (field: {model: string} , value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
    }

    save = async () => {
        const isOk = Helper.isNullOrEmpty(this.props.entity.SQL) ? await DialogHelper.confirm(Helper.getTranslation("InfoTool.NoSqL")) : true;
        if (isOk)
            this.common.handlePostSave(true, true);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} title={this.props.title} />;
    }
};

interface FolgeSQLEntity extends FolgeSQL, Entity { };

interface EditFolgeSQLProps extends AppBaseProps {
    entity: FolgeSQLEntity;
}

class EmailTemplateGrid extends React.Component<{ ids: number[], onChange: (ids: number[]) => void}>{
    private emailTemplates: any[];
    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            //{
            //    field: "id",
            //    title: "Id"
            //},
            {
                field: "Name",
                title: Helper.getTranslation("Standard.Name"),
                template: (data) => {
                    const item = this.emailTemplates.find(et => et.Id == data.id)
                    return item.Name
                }
            },
            {
                field: "Type",
                title: Helper.getTranslation("Standard.Typ"),
                template: (data) => {
                    const item = this.emailTemplates.find(et => et.Id == data.id)
                    const type = item.Type.toLowerCase();
                    switch (type) {
                        case "general":
                            return Helper.getTranslation("Server.Allgemein");
                        case "address":
                            return Helper.getTranslation("Adresse.Adresse");
                        case "machine":
                            return Helper.getTranslation("BrowserTitle.Machine.Available");
                        case "usersettings":
                            return Helper.getTranslation("Server.User");
                        case "contact":
                            return Helper.getTranslation("Adresse.Ansprechpartner");
                        case "project":
                            return Helper.getTranslation("Field.Vorgang.projnr");
                        case "material":
                            return Helper.getTranslation("Vorgang.Material");
                        case "ticket":
                            return Helper.getTranslation("WebSMS.ReportMetadata.TargetEntity.Ticket");
                        case "resource":
                            return Helper.getTranslation("WebSMS.ReportMetadata.TargetEntity.Resource");
                        case "resourceplanning":
                            return Helper.getTranslation("BrowserTitle.Assigment.Available");
                        case "customreport":
                            return Helper.getTranslation("WebSMS.ReportMetadata.TargetEntity.CustomReport");
                        case "weeklyreport":
                            return Helper.getTranslation("WebSMS.ReportMetadata.TargetEntity.WeeklyReport");
                        case "servicereport":
                            return Helper.getTranslation("BrowserTitle.Report.Available");
                        default:
                            return type;
                    }
                }
            }
        ]
    }

    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Helper.getTranslation("WebSMS.Reminder.Add"),
            enabled: true,
            type: ToolBarStandardButtonType.NEW
        },
        {
            caption: Helper.getTranslation("Standard.Loeschen"),
            enabled: true,
            type: ToolBarStandardButtonType.DELETE
        },

    ];

    constructor(props) {
        super(props)
        this.loadTemplates();
    }

    private loadTemplates = async () => {
        const url = "InfotoolJob/GetEmailTemplates";
        const data = await HTTPService.get(url);
        this.emailTemplates = data;
        this.setState({})
    }

    private onClick = async (type: ToolBarStandardButtonType, item) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const url = "DynamicSearch/Window/emailTemplate?multi=true&displayPattern=[[name]]";
                const sheet = General.Sheet.Manager.createSheetWithUrl(url);
                sheet.bind(SheetEventType.ItemsSelected, (data) => {
                    let ids = this.props.ids;
                    ids = ids.concat(data.data.map((item) => item.id)).filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    })
                    this.props.onChange(ids)
                })
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
                if (isOk) {
                    const ids = this.props.ids.filter(f => f != item.id)
                    this.props.onChange(ids)
                }
                break;
        }
    }

    private sortIds = (a: number, b: number) => {
        const item_a = this.emailTemplates.find(et => et.Id == a);
        const item_b = this.emailTemplates.find(et => et.Id == b);
        if (item_a.Name < item_b.Name) {
            return -1;
        }
        if (item_a.Name > item_b.Name) {
            return 1;
        }
        return 0;
    }

    render() {
        if (!Helper.hasValue(this.emailTemplates))
            return null;
        const ids = this.props.ids
            .sort(this.sortIds)
            .map(id => { return { id: id } })
        return (
            <div className="flex-container">
                <Grid
                    data={ids}
                    options={this.gridOptions}
                    id="infotool_emails"
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onClick}
                />
            </div>
        );
    }


}


const importJSON = () => {

    return new Promise<JobEntity>((resolve, reject) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);
        const onFileSelect = async (file: File) => {
            const formData = new FormData();
            formData.append("file", file);

            const result = await HTTPService.post<JsonResultClass>("InfotoolJob/Import", formData);
            if (result.Code == 0) {
                resolve(result.Data)
            } else {
                reject(result.Message)
            }
            root.unmount();
        }


        root.render(
            <>
                <ImportJSONDialog cancel={() => { resolve(null) }} fileSelect={onFileSelect}/>
            </>
        );

    })



}

interface ImportJSONDialogProps {
    cancel: () => void;
    fileSelect: (file: File) => Promise<void>;
}

class ImportJSONDialog extends React.Component<ImportJSONDialogProps, {selectedFile: any}>{
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("InfoTool.Select"),
        actions: [
            {
                action: () => {
                    this.props.cancel();
                },
                label: Helper.getTranslation("Standard.CloseBtn"),
                primary: false
            },{
                action: () => {
                    this.disableButton();
                    if (this.state.selectedFile) {
                        this.props.fileSelect(this.state.selectedFile.rawFile)
                        return true;
                    }
                    return false;
                },
                label: Helper.getTranslation("Standard.Select"),
                primary: true
            }
        ],
        width: 350,
        afterClose: () => {
            //this.setFile(null)
        },
        open: true
    };
    private button: HTMLButtonElement;
    private uploadInputRef: HTMLInputElement;
    private upload: kendo.ui.Upload;
    private dialogRef: Dialog;
    constructor(props) {
        super(props)

        this.state = {
            selectedFile: null
        }
    }

    private enabledButton = () => {
        this.button.removeAttribute('disabled')
    }

    private disableButton = () => {
        this.button.setAttribute('disabled', 'disabled')
    }

    setFile = (file) => {
        
        this.setState({ selectedFile: file }, () => {
            if (file)
                this.enabledButton();
            else
                this.disableButton()
        });
    }

    private setFileUpload = () => {
        this.upload = $(this.uploadInputRef).kendoUpload({
            select: (event) => {
                const file = event.files[0];
                if (!Helper.hasValue(file.validationErrors) || file.validationErrors.length == 0) {
                    this.setFile(file)
                } else {
                    this.setFile(null)
                }
                
            },
            remove: (event) => {
                if (this.upload.getFiles().length == 1) {
                    this.setFile(null)
                }
            },
            multiple: false,
            validation: {
                allowedExtensions: ['.JSON']
            }
        }).data("kendoUpload");
    }

    componentDidMount() {
        this.button = document.querySelector('div.k-dialog button.k-button-solid-primary');
        this.disableButton();
        this.setFileUpload();
    }

    render() {
        return (
            <Dialog {...this.dialogProps} ref={(ref) => { this.dialogRef = ref}} >
                <input name='fileUpload' type='file' ref={ref => this.uploadInputRef = ref} />
            </Dialog>);
    }
}